let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4O2Qt")).then(() => parcelRequire('loSHx'));